import { HomeIcon } from "@radix-ui/react-icons";
import { Flex, Grid, Heading, IconButton } from "@radix-ui/themes";
import { FC } from "react";
import "Wrapper.css";
import { useGetOrder } from "./api";
import { Footer } from "./modules";
import { Error, Login, LoginProps, TrackingDetail } from "./pages";

export const Wrapper: FC = () => {
  const { data, loading, error, call, clear } = useGetOrder();

  const onSubmit: LoginProps["onSubmit"] = (customerId, orderId) => {
    const cleanedCustomerId = customerId.replace(/^K/i, "");
    call({ customerID: cleanedCustomerId, orderID: Number(orderId) });
    const params = new URLSearchParams({
      customerid: cleanedCustomerId,
      orderid: orderId,
    });
    window.history.pushState({}, document.title, `?${params.toString()}`);
  };

  const onBackClick = () => {
    window.history.pushState({}, document.title, "/");
    clear();
  };

  return (
    <Grid gap="6">
      <Flex justify="between" wrap="wrap-reverse" gap="5" align="center">
        <Flex gap="2">
          <Heading size="7">Auftragsstatus</Heading>
          {data && (
            <IconButton size="2" onClick={onBackClick}>
              <HomeIcon />
            </IconButton>
          )}
        </Flex>
        <img
          src={`${process.env.PUBLIC_URL}/logo.svg`}
          alt="Logo"
          className="wrapper--logo"
          onClick={onBackClick}
        />
      </Flex>
      {!data && <Login loading={loading} onSubmit={onSubmit} />}
      {error && <Error />}
      {data && (
        <TrackingDetail
          orderPos={data.orderPos}
          shippingAddress={data.shippingAddress}
          orderID={data.orderID}
          orderDate={data.orderDate}
          shippingMethodID={data.shippingMethodID}
          dateExpected={data.dateExpected}
        />
      )}
      <Footer />
    </Grid>
  );
};
